import { Form, Input, Modal, Select, Space, notification } from 'antd';
import CustomButton from 'components/custom-button';
import { TYPE_NEW, TYPE_SOUND, UPLOAD_TYPE } from 'constants/common';
import { REQUIRED } from 'constants/rule-form';
import { useEffect, useState } from 'react';
import { API } from 'service/api-route';
import AxiosUtils from 'utils/axios-utils';
import styles from '../styles.module.scss';
import { CHECK_FILE } from 'utils/rule-form';
import CustomizedUpload from 'components/customized-upload';
import { SERVER_FILE_ENDPOINT } from 'constants/envs';
const { Option } = Select;
interface DataPost {
  name: string;
  link: any;
  status: string;
  type: string;
}

interface Props {
  isOpen: boolean;
  handleCancelCreateEditModal: () => void;
  onChangeStatusUpdateData: () => void;
  valueUserSelected: any;
}

const ModalCreateEdit = ({
  isOpen,
  valueUserSelected,
  handleCancelCreateEditModal,
  onChangeStatusUpdateData,
}: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: DataPost) => {
    values.link = values?.link?.fileKey;

    console.log(values);
    setLoading(true);
    if (valueUserSelected?.id) {
      try {
        const res: any = await AxiosUtils.put(`${API.editSound}/${valueUserSelected?.id}`, values);
        if (res?.status === 200) {
          handleCancelCreateEditModal();
          onChangeStatusUpdateData();
          notification.success({
            message: 'Thành công',
            description: 'Sửa thành công!',
            duration: 4,
          });
        }
      } catch (error) {
        notification.error({
          message: 'Không thành công',
          description: 'Có lỗi xảy ra, vui lòng thử lại.',
          duration: 4,
        });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const res: any = await AxiosUtils.post(API.createSounds, values);
        if (res?.status === 201) {
          handleCancelCreateEditModal();
          onChangeStatusUpdateData();
          notification.success({
            message: 'Thành công',
            description: 'Tạo thành công!',
            duration: 4,
          });
        }
      } catch (error) {
        notification.error({
          message: 'Không thành công',
          description: 'Có lỗi xảy ra, vui lòng thử lại.',
          duration: 4,
        });
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      name: valueUserSelected?.name || '',
      link: valueUserSelected?.link
        ? {
            fileKey: valueUserSelected?.link,
            fileUrl: `${SERVER_FILE_ENDPOINT}/${valueUserSelected.link}`,
          }
        : null,
      status: valueUserSelected?.status || undefined,
      type: valueUserSelected?.type || undefined,
    });
  }, [form, valueUserSelected]);

  return (
    <>
      <Modal
        forceRender
        open={isOpen}
        title={valueUserSelected?.id ? 'Sửa âm thanh' : 'Thêm âm thanh'}
        onCancel={handleCancelCreateEditModal}
        width={800}
        getContainer={false}
        footer={false}
      >
        <Form
          name="form"
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <label className={styles.labelInput} htmlFor="name">
            Tên âm thanh
          </label>
          <Form.Item
            name="name"
            rules={[
              REQUIRED,
              {
                max: 100,
                message: 'Không được quá 100 kí tự',
              },
            ]}
            wrapperCol={{ span: 24 }}
          >
            <Input placeholder="Nhập tên âm thanh" size="large" />
          </Form.Item>

          <label className={styles.labelInput} htmlFor="type">
            Loại
          </label>
          <Form.Item rules={[REQUIRED]} name="type" wrapperCol={{ span: 24 }}>
            <Select value={TYPE_SOUND.MUSIC} placeholder="Chọn loại âm thanh" size="large">
              <Option value={TYPE_SOUND.MUSIC}>Âm thanh</Option>
              <Option value={TYPE_SOUND.SOUND_EFFECT}>Hiệu ứng</Option>
              <Option value={TYPE_SOUND.PAY_THE_BET}>Trả kèo</Option>
              <Option value={TYPE_SOUND.SYNTHETIC}>Tổng hợp</Option>
            </Select>
          </Form.Item>

          <label className={styles.labelInput} htmlFor="type">
            Trạng thái
          </label>
          <Form.Item rules={[REQUIRED]} name="status" wrapperCol={{ span: 24 }}>
            <Select value={TYPE_NEW.PUBLIC} placeholder="Chọn trạng thái" size="large">
              <Option value={TYPE_NEW.PUBLIC}>Công khai</Option>
              <Option value={TYPE_NEW.PRIVATE}>Ẩn</Option>
            </Select>
          </Form.Item>

          <label className={styles.labelInput} htmlFor="link">
            Tệp âm thanh
          </label>
          <Form.Item name="link" wrapperCol={{ span: 24 }} rules={[CHECK_FILE]}>
            <CustomizedUpload type={UPLOAD_TYPE.AUDIO} maxFileSize={5} />
          </Form.Item>

          <div className="d-flex justify-center">
            <Space size="large">
              <CustomButton
                bgColor="secondary-green"
                text="Lưu"
                htmlType="submit"
                loading={loading}
              />
              <CustomButton
                text="Hủy"
                bgColor="primary-grey"
                htmlType="button"
                onClick={handleCancelCreateEditModal}
              />
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ModalCreateEdit;
